import { getRoleColor } from './roleColors';
import { roleLabel, SCOPE_KEY_LABELS, scopeSummary, type RoleGrant } from '../../domain/access';

/** Un badge par rôle, suivi du résumé de son périmètre ; le détail est dans le `title`. */
export const AccessBadgeList = ({ access }: { access: RoleGrant[] }) => {
  if (access.length === 0) return <span className="text-xs text-zinc-400">—</span>;

  return (
    <span className="inline-flex flex-wrap items-center gap-x-3 gap-y-1">
      {access.map(grant => {
        const tokens = getRoleColor(grant.role);
        const detail = grant.scopes
          .filter(scope => scope.values.length > 0)
          .map(scope => `${SCOPE_KEY_LABELS[scope.key]} : ${scope.values.join(', ')}`)
          .join('\n');
        return (
          <span key={grant.role} className="inline-flex items-center gap-1.5" title={detail || 'Tout le compte'}>
            <span className={`rounded-md text-[10px] font-medium px-1.5 py-0.5 ${tokens.bg} ${tokens.text}`}>
              {roleLabel(grant.role)}
            </span>
            <span className="text-[10px] text-zinc-500">{scopeSummary(grant)}</span>
          </span>
        );
      })}
    </span>
  );
};
